<template>
  <FinancialsOverviewCard title="Plan Length Remaining" expandable>
    <template #default>
      <div class="d-flex align-center text-truncate flex-wrap">
        <h4 class="text-h4 mr-2">{{ remainingMonths }}</h4>
        <p class="text-neutral font-weight-medium">
          ends {{ lastPaymentDate }} ({{ remainingDays }})
        </p>
      </div>
    </template>
    <template #details>
      <dl class="dl-vertical">
        <dt>Plan length:</dt>
        <dd>{{ debtPaymentPlan.data?.planLengthInMonths }} months</dd>

        <dt>Set up date:</dt>
        <dd>{{ createdAt }}</dd>
      </dl>
    </template>
  </FinancialsOverviewCard>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import FinancialsOverviewCard from "../../components/FinancialsOverviewCard.vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import { formatDate, daysFromToday } from "@/helpers/dateHelper"

  export default defineComponent({
    components: {
      FinancialsOverviewCard,
    },
    data() {
      return {
        debtPaymentPlan: useCurrentAccountStore().activeDebtPaymentPlan,
      }
    },
    computed: {
      createdAt() {
        const date = this.debtPaymentPlan.data?.createdAt
        if (!date) return
        return formatDate(date)
      },
      remainingMonths() {
        const monthsLeft =
          this.debtPaymentPlan.data?.remainingPaymentMonths ?? 0
        return monthsLeft + (monthsLeft === 1 ? " month" : " months")
      },
      remainingDays() {
        const date = this.debtPaymentPlan.data?.lastPaymentDate
        if (!date) return
        const days = Math.abs(daysFromToday(date))
        return days + (days === 1 ? " day" : " days")
      },
      lastPaymentDate() {
        const date = this.debtPaymentPlan.data?.lastPaymentDate
        if (!date) return
        return formatDate(date)
      },
    },
  })
</script>
